import { mapGetters } from 'vuex';

export default {
	name: 'SkuItem',

	props: {
		dataSrc: {
			type: Object,
			default: () => {}
		},
	},

	data() {
		return {}
	},

	computed: {
    ...mapGetters([
      'primaryBtnBackgroundColor',
    ]),
  },

	methods: {
		clickCard() {
			this.$emit('onClickSku', {
				product_id: this.dataSrc.product_id,
			});
		}
	}
}